import React, { useContext } from 'react';
import { Box, Typography } from '@material-ui/core';

import { colors } from 'theme/color-palette';
import useStyles from './GenerateCards.style';
import { FEATURES } from 'helper/basicFeatureFlag';
import { UserPortalContext } from 'context/appcontext';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

const { PURPLE, TOGGLE_ACTIVE } = colors;

const Tag = ({ item }) => {
	const classes = useStyles();
	const portalUserContext = useContext(UserPortalContext);
	const { customerType, isStudent } = portalUserContext;
	const showCharterOnlyTag = FEATURES[customerType].TEMPLATE_PAGE.SHOW_CHARTER_TAG_ON_CARD;

	const checkStudent = isStudent && item?.isDisabledForStudent;
	if (showCharterOnlyTag && (item?.isDisabled || checkStudent)) {
		return (
			<Box className={classes.tag}>
				<LockOutlinedIcon style={{ height: '16px', width: '16px', marginTop: '8px' }} />
			</Box>
		);
	}

	if (item.templateVersion) {
		return (
			<Box className={classes.tag} style={{ background: TOGGLE_ACTIVE }}>
				<Typography style={{ color: PURPLE, fontSize: '12px' }}>{item.templateVersion}</Typography>
			</Box>
		);
	}

	return null;
};

export default Tag;
